module.exports = __webpack_public_path__ + "img/back.da7f4c8d.png";